import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import PropTypes from 'prop-types';
import debounce from 'lodash.debounce';
import classNames from 'classnames';
import RangeFilter from '@blaze-react/range-filter';
import { useRouter } from 'next/router';
import Select from '@blaze-react/select';
import { parseUrl } from 'query-string';
import { useGetSingleEntitySchema } from '../../../hooks';
import { getSelectOptions, getIntersectedProp, getRangeValue, calculateMinMax } from '../helpers';
import { decodeValue } from '../helpers/decode-encode';
const Range = ({
  rangeInterval,
  label,
  entity,
  propsToDisplay,
  dataAggregations,
  updateFilterValues,
  filterValues,
  shouldSearch,
  elementTitle,
  unit
}) => {
  const router = useRouter();
  const debounceAmount = shouldSearch ? 1200 : 400;
  const {
    query
  } = parseUrl(decodeValue(router.asPath));
  const hasMultipleOptions = propsToDisplay.length > 1;
  const initialRangeOption = getIntersectedProp(query, propsToDisplay) || propsToDisplay[0];
  const rangeOption = filterValues[initialRangeOption] && filterValues[initialRangeOption].selectedOption || initialRangeOption;
  const rangeValue = filterValues[rangeOption];
  const {
    data: {
      getEntitySchema = {}
    } = {},
    loading
  } = useGetSingleEntitySchema(entity, !hasMultipleOptions);
  if (loading || !rangeOption || !rangeValue) return '';
  const options = getSelectOptions(getEntitySchema, propsToDisplay);
  const {
    min,
    max
  } = calculateMinMax(dataAggregations[rangeOption], rangeInterval);
  const minValue = rangeValue.minValue < min ? min : rangeValue.minValue;
  const maxValue = rangeValue.maxValue > max ? max : rangeValue.maxValue;
  const valueToUse = _objectSpread(_objectSpread({}, rangeValue), {}, {
    min,
    max,
    minValue,
    maxValue
  });
  const handleChange = debounce((option, value) => {
    updateFilterValues({
      [option]: _objectSpread(_objectSpread({}, value), {}, {
        selectedOption: rangeOption
      })
    }, shouldSearch);
  }, debounceAmount);
  let displayLabel = '';
  if (!hasMultipleOptions) {
    displayLabel = label;
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, elementTitle && /*#__PURE__*/React.createElement("div", {
    className: "heading heading--section"
  }, elementTitle), hasMultipleOptions && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("label", null, label), /*#__PURE__*/React.createElement(Select, {
    value: rangeOption,
    id: rangeOption,
    options: options,
    required: true,
    onChange: ({
      value
    }) => {
      const updatedOptions = {};
      propsToDisplay.forEach(prop => {
        const {
          min: aggMin,
          max: aggMax
        } = calculateMinMax(dataAggregations[prop], rangeInterval);
        const initValue = getRangeValue(null, rangeInterval, aggMin, aggMax);
        updatedOptions[prop] = _objectSpread(_objectSpread({}, initValue), {}, {
          selectedOption: value
        });
      });
      updateFilterValues(updatedOptions, false);
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: classNames('range-filter-wrapper', {
      'has-unit': unit
    }),
    style: unit ? {
      '--unit': `"${unit}"`
    } : {}
  }, /*#__PURE__*/React.createElement(RangeFilter, {
    key: `${rangeOption}-${min}-${max}`,
    name: rangeOption,
    label: displayLabel,
    value: valueToUse,
    id: rangeOption,
    onChange: ({
      value
    }) => {
      handleChange(rangeOption, value);
    }
  })));
};
Range.propTypes = {
  propsToDisplay: PropTypes.array.isRequired,
  entity: PropTypes.string.isRequired,
  filterValues: PropTypes.object.isRequired,
  updateFilterValues: PropTypes.func.isRequired,
  shouldSearch: PropTypes.bool,
  rangeInterval: PropTypes.number,
  label: PropTypes.string,
  elementTitle: PropTypes.string,
  dataAggregations: PropTypes.object.isRequired,
  unit: PropTypes.string
};
Range.defaultProps = {
  shouldSearch: false,
  rangeInterval: 1,
  label: '',
  elementTitle: '',
  unit: ''
};
export default Range;
//# sourceMappingURL=Range.js.map